import { useEffect, useState } from "react";

/**
 * Custom hook to detect user's motion preferences
 * Respects prefers-reduced-motion setting for accessibility
 */
export const useReducedMotion = (): boolean => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    // Check if the browser supports the media query
    if (typeof window !== "undefined" && window.matchMedia) {
      const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

      // Set initial value
      setPrefersReducedMotion(mediaQuery.matches);

      // Listen for changes
      const handleChange = (event: MediaQueryListEvent) => {
        setPrefersReducedMotion(event.matches);
      };

      // Add listener (use deprecated addListener for broader browser support)
      if (mediaQuery.addListener) {
        mediaQuery.addListener(handleChange);
      } else {
        mediaQuery.addEventListener("change", handleChange);
      }

      // Cleanup
      return () => {
        if (mediaQuery.removeListener) {
          mediaQuery.removeListener(handleChange);
        } else {
          mediaQuery.removeEventListener("change", handleChange);
        }
      };
    }
  }, []);

  return prefersReducedMotion;
};

export default useReducedMotion;
